/* global axios */
import ApiClient from './ApiClient';

class CampaignIntelligenceReportsAPI extends ApiClient {
  constructor() {
    super('campaign_intelligence_reports', { accountScoped: true });
  }

  createReport(params) {
    return axios.post(this.url, params);
  }
}

export default new CampaignIntelligenceReportsAPI();
